export default __webpack_public_path__ + "static/media/learnmore-money.075b264a.svg";